import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { bool, number } from 'prop-types';

import ShopByPrice from './ShopByPrice';
import PageSidebar from './PageSidebar';

import '../styles/CategoryMobileSideBar.css';

function CategoryMobileSideBar({ loading, productMaxPrice, productCount }) {
    return (
        <Navbar
            expand={false}
            className={'category-mobile-sidebar'}>
            <div>
                <Navbar.Toggle /> SIDEBAR
                <Navbar.Offcanvas
                    placement={'start'}
                >
                    <Offcanvas.Header
                        closeButton
                    >
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <PageSidebar />
                        {((productCount || 0) > 0 || loading) && <ShopByPrice
                            loading={loading}
                            productMaxPrice={productMaxPrice}
                        />}
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </div>
        </Navbar>
    );
}

CategoryMobileSideBar.propTypes = {
    loading: bool,
    productMaxPrice: number,
    productCount: number,
};

export default CategoryMobileSideBar;